import { type Mixpanel } from "mixpanel-browser";

import { env } from "@/env/env";

let mixpanelInstance: Mixpanel | null = null;

export const initializeMixpanel = async () => {
  const environment = env();
  if (environment.MIXPANEL_ENABLED) {
    mixpanelInstance = (await import("mixpanel-browser")).default;

    mixpanelInstance.init(environment.MIXPANEL_TOKEN, {
      // the backend determines which proxy to use.
      // the token determines which mixpanel instance the data
      // will end up in, not the proxy.
      api_host: environment.MIXPANEL_HOST,
      debug: environment.MIXPANEL_DEBUG,
      secure_cookie: window?.location.protocol === "https:",
      ignore_dnt: true,
    });
  }
};

export const trackEvent = (
  event: string,
  properties?: Record<string, unknown>
) => {
  mixpanelInstance?.track(event, properties);
};
